import { CircularProgress, Typography } from '@mui/material'
const Loading = ({
  message,
  extraMessage,
  className,
}: {
  message?: string
  extraMessage?: string
  className?: string
}) => (
  <div
    className={`flex h-full w-full flex-col items-center justify-center gap-2 ${
      className ?? ''
    }`}
  >
    <CircularProgress />
    <Typography>{message ?? 'Loading...'}</Typography>
    {extraMessage && <Typography>{extraMessage}</Typography>}
  </div>
)

export default Loading
